/**
 * Application configuration for user-facing branding
 */
import packageJson from "../../package.json";

export const APP_DISPLAY_NAME = packageJson.displayName || "Odin Sight";
